import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomTable from "../../../blueplanitUtils/CustomTabels";
import { EducationalModelPopUp } from "../../../components/ProfileEditpopUp/EductationModelPopup";
import AddNoteBox from "./addNote";
import PersonalInformationModelPopup from "../../../components/modelpopup/PersonalInformationModelPopup";

const EducationComponent = () => {
  const { Empid } = useParams();
  const educationData = useSelector((state) => state.employee.educationData);
const educationFields=["education Level", "college", "university", "degree", "field of Study", "type f Study", "from","to"]
  const DataLabel = ["educationLevel", "college", "university", "degree", "fieldOfStudy", "typeOfStudy", "from","to"]
   const DateField={
    from:true,
    to:true
   }
  return (
    <>
      <CustomTable
        title="Educational Info"
        data={educationData}
        dataLabel={DataLabel}
        columns={educationFields}
        Id="education_info"
        showEdit={Empid}
        dateFieldsMap={DateField}
      />
      <EducationalModelPopUp />
      <AddNoteBox name={"EducationNote"} />
      <PersonalInformationModelPopup name={"EducationNote"}/>
    </>
  );
};

export default EducationComponent;
